<span *ngIf="waitTime > 0;else noTimeLeft"
      [class.color-orange]="waitTime > warnThreshold && waitTime <= infoThreshold"
      [class.color-warn]="waitTime <= warnThreshold">{{waitTimeLabel}}</span>
<ng-template #noTimeLeft>
  <span i18n="App Timer|Time is up title@@app-timer-time-is-up-title" class="color-warn">Time is up!</span>
</ng-template>
